import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CustomDomains } from './shared/custom-domains/custom-domains-list';

@Component({
  selector: 'tf-settings-page-custom-domains',
  imports: [CommonModule, CustomDomains, TranslateModule],
  templateUrl: './settings-custom-domains.component.html',
  styleUrl: './settings-custom-domains.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomDomainsSettings {}
